var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconUpvoteOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 28,
  viewBox: "0 0 27 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.8843 26.1951L19.0561 16.2845H25.3063C25.5715 16.2845 25.8129 16.1284 25.9296 15.8824C26.0442 15.6363 26.0184 15.341 25.8557 15.1245L14.0497 1.27983C13.9182 1.10266 13.7154 1 13.5004 1C13.2854 1 13.0826 1.10266 12.951 1.27983L1.14512 15.1245C1.04883 15.2525 1 15.4085 1 15.5646C1 15.6729 1.02376 15.7812 1.07122 15.8824C1.18789 16.1285 1.4293 16.2845 1.69447 16.2845H7.94466L7.77279 26.1951C7.77279 26.593 8.0834 26.915 8.46725 26.915H18.1898C18.5736 26.915 18.8843 26.593 18.8843 26.1951Z",
  fill: "#CCDAFD",
  stroke: "#001246",
  strokeWidth: 1.8
})));
export default SvgIconUpvoteOn;